import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheck = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "check",
	"data-name": "check",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("polyline", {
		className: "plan2plate-icon",
		points: "6.27 12 10.09 15.82 17.73 8.18",
		id: "polyline1",
		transform: "matrix(1.8740828,0,0,1.8740828,-10.488994,-10.784122)"
	})]
});
const ForwardRef = forwardRef(SvgCheck);
export default ForwardRef;
